import Filters from './Filters';

export default Filters;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Filters/index.js